import React          from 'react';
import { withRouter } from 'react-router';

class Hello extends React.Component {

	componentDidMount() {
		document.title = document.title.split("|")[0] + ' | Hello';
		fetch('https://dev-integration.boisestate.edu/ws/rest/Perceptive/cobe/aar', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
		fetch('https://test-integration.boisestate.edu/ws/rest/Perceptive/cobe/aar', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
		fetch('https://integration.boisestate.edu/ws/rest/Perceptive/cobe/aar', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
		fetch('https://dev-integration.boisestate.edu/ws/rest/Public/v1/coursesearch', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
		fetch('https://test-integration.boisestate.edu/ws/rest/Public/v1/coursesearch', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
		fetch('https://integration.boisestate.edu/ws/rest/Public/v1/coursesearch', {
			method: "POST",
			body: "[]",
			headers: {
				"Content-Type": "application/json",
				"Authorization": "Basic TEST"
			},
			credentials: 'include',
			mode: 'cors'
		}).then(function(response) {
			console.log(response.status)     //=> number 100–599
			console.log(response.statusText) //=> String
			console.log(response.headers)    //=> Headers
			console.log(response.url)        //=> String

			return response.text()
		}, function(error) {
			console.log(error.message) //=> String
		})
	}

	render() {
		return (
			<div className='border-preview'>
			Preview Mode
			</div>
		);
	}
}

export default withRouter(Hello);
